import BaseService from "src/packages/BaseService";

export default class OrderService extends BaseService {
	static get className() {
		return "order";
	}

	static saveConstruction(data) {
		if (data.id) {
			return this.updateConstruction(data.id, data);
		} else {
			return this.createConstruction(data);
		}
	}

	static createConstruction(data) {
		return this.getService().post("construction", data).then(
			(response) => {
				return response.data;
			}
		);
	}

	static updateConstruction(id, data) {
		data._method = "put";
		return this.getService().post("construction" + "/" + id, data).then(
			(response) => {
				return response.data;
			}
		);
	}
};
